const ACTIVE_CLUB_STORAGE_KEY = "activeClubId";
const ORIGINAL_ACTIVE_CLUB_STORAGE_KEY = "preImpersonationActiveClubId";

export const suspendActiveClubSelection = (storage) => {
  const activeClubId = storage.getItem(ACTIVE_CLUB_STORAGE_KEY);
  if (activeClubId) {
    storage.setItem(ORIGINAL_ACTIVE_CLUB_STORAGE_KEY, activeClubId);
  } else {
    storage.removeItem(ORIGINAL_ACTIVE_CLUB_STORAGE_KEY);
  }
  storage.removeItem(ACTIVE_CLUB_STORAGE_KEY);
  return activeClubId;
};

export const setImpersonatedActiveClub = (storage, clubId) => {
  if (clubId) {
    storage.setItem(ACTIVE_CLUB_STORAGE_KEY, String(clubId));
  }
};

export const restoreActiveClubSelection = (storage, activeClubId) => {
  if (activeClubId) {
    storage.setItem(ACTIVE_CLUB_STORAGE_KEY, activeClubId);
  }
};

export const endImpersonationSession = (storage) => {
  const originalActiveClubId = storage.getItem(
    ORIGINAL_ACTIVE_CLUB_STORAGE_KEY
  );
  storage.removeItem("impersonate");
  storage.removeItem(ACTIVE_CLUB_STORAGE_KEY);
  storage.removeItem(ORIGINAL_ACTIVE_CLUB_STORAGE_KEY);
  restoreActiveClubSelection(storage, originalActiveClubId);
};
